import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    redirect: '/index',
    component: () => import( '@/components/Home.vue'),
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/components/main/Main.vue'),
      },
      {
        path: '/product-*',
        name: 'Product',
        component: () => import('@/components/product/Product.vue'),
      },
      {
        path: '/newsDetail',
        name: 'News',
        component: () => import('@/components/news/newsDetail.vue'),
      },
      {
        path: '/news',
        name: 'News',
        component: () => import('@/components/news/News.vue'),
      },
      {
        path: '/application',
        name: 'Application',
        component: () => import('@/components/application/Application.vue'),
      },
      {
        path: '/company',
        name: 'Company',
        component: () => import('@/components/company/Company.vue'),
      },
      {
        path: '/employ',
        name: 'Employ',
        component: () => import('@/components/employ/Employ.vue'),
      },
      {
        path: '/jobs',
        name: 'Jobs',
        component: () => import('@/components/employ/jobs.vue'),
      },
      {
        path: '/linkUs',
        name: 'LinkUs',
        component: () => import('@/components/employ/linkUs.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  // mode: "history",
  routes
})
// 挂载路由导航守卫

router.beforeEach((to, from, next) => {
  //to and from are Route Object,next() must be called to resolve the hook}
  // to 将要访问的路径  from 从哪里来  next() 放行  next('/login') 强制跳转
  // if(to.path === '/login') {
  //   return next();
  // }
  // 先获取token
  // const tokenStr = window.sessionStorage.getItem('token')
  // if(!tokenStr) {
  //   return next('/login')
  // }
  next();
})

export default router
